<template>
  <sky-charts
    ref="chart"
    :queryCondition="condition"
    :config="chartConfig"
    legendPosition="bottom"
    :showTitle="false"
    :showShadow="false"
    :extend="extend"
    :chartData="data"
    :chartsLoading="loading"
  >
    <div
      slot="header"
      class="header"
    >
      <el-select
        v-model="selectNum"
        placeholder="点击次数"
        size="mini"
        @change="changeNum"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="title">{{title}}</div>
      <el-select
        v-model="selectPct"
        placeholder="点击率"
        size="mini"
        @change="changePct"
      >
        <el-option
          v-for="item in option"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
  </sky-charts>
</template>

<script>
// import dayjs from "dayjs";
import mixins from './ga_mixins'
import { googleOption, googleOptions } from '@/common/dictionary.js'
import filters from '@/mixins/filters.js'
export default {
  name: 'advertising-series',
  mixins: [mixins],
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    customTitle: {
      type: [Boolean, String],
      default: false
    }
  },
  data() {
    return {
      selectNum: 'IMPRESSIONS',
      selectPct: 'clickRate',
      selectName: '展示次数',
      options: googleOption,
      option: googleOptions,
      tabName: '',
      tabItem: '',
      extend: {
        series: {
          label: {
            show: true,
            position: 'top',
            formatter(val) {
              if (val.seriesName == '点击率') {
                val.value = val.value + '%'
                val.data = val.data + '%'
              }
              if (
                val.seriesName === '展示次数' ||
                val.seriesName === '点击次数'
              ) {
                val.value = filters.filters.thousands(val.value)
                val.data = filters.filters.thousands(val.data)
              }
              if (val.seriesName === '消耗' || val.seriesName === '点击均价') {
                val.value = filters.filters.rmb(val.value)
                val.data = filters.filters.rmb(val.data)
              }
              return val.value
            }
          },
          smooth: false
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dotted',
              opacity: 0
            }
          }
        },
        xAxis: {
          axisLabel: {
            formatter(val) {
              if (val.length > 5) {
                return `${val.slice(0, 3)}...`
              } else {
                return val
              }
            }
          }
        },
        tooltip: {
          show: true,
          formatter(val) {
            val.forEach(item => {
              if (item.seriesName == '点击率') {
                item.value = item.value + '%'
                item.data = item.data + '%'
              }
              if (
                item.seriesName === '展示次数' ||
                item.seriesName === '点击次数'
              ) {
                item.value = filters.filters.thousands(item.value)
                item.data = filters.filters.thousands(item.data)
              }
              if (
                item.seriesName === '消耗' ||
                item.seriesName === '点击均价'
              ) {
                item.value = filters.filters.rmb(item.value)
                item.data = filters.filters.rmb(item.data)
              }
            })
            switch (val.length) {
              case 0:
                return ''
              case 1:
                return `${val[0].axisValue}<br>
                  ${val[0].seriesName}：${val[0].value}`
              case 2:
                return `${val[0].axisValue}<br>
                  ${val[0].seriesName}：${val[0].value}<br>
                  ${val[1].seriesName}：${val[1].value}`
            }
          }
        }
      },
      chartConfig: {
        name: '广告系列',
        type: 'veHistogram',
        height: '400px',
        columns: [],
        chartSettings: {
          // 设置别名
          labelMap: {
            name: '名称',
            impressions: '展示次数',
            exchangeRateCost: '消耗',
            clicks: '点击次数',
            clickRate: '点击率',
            clickOnAverage: '点击均价'
          },
          // 双纵轴
          showLine: [],
          axisSite: {
            right: ['clickOnAverage']
          }
        },
        grid: {
          left: 10,
          right: 10,
          top: 30
        }
      },
      label: {
        impressions: '展示次数',
        exchangeRateCost: '消耗',
        clicks: '点击次数',
        clickRate: '点击率',
        clickOnAverage: '点击均价'
      },
      data: []
    }
  },
  watch: {
    condition: {
      handler(val) {
        this.data = val.data
        this.tabName = val.tabName
        this.tabItem = val.tabItem
        this.chartConfig.columns = [
          'name',
          this.switch(this.selectNum),
          this.selectPct
        ]
        this.chartConfig.chartSettings.showLine = [this.selectPct]
        this.chartConfig.chartSettings.axisSite.right = [this.selectPct]
        if (val.extend) this.extend = { ...this.extend, ...val.extend }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    title() {
      let { customTitle, tabName, selectName } = this
      if (customTitle) {
        return customTitle || ''
      } else {
        return tabName=='设备'?`${tabName || ''}${selectName || ''}`:`${tabName || ''}${selectName || ''}TOP10`
      }
    }
  },
  methods: {
    // 改变排序字段
    changePct(val) {
      this.selectPct = val
      this.chartConfig.columns = [
        'name',
        this.switch(this.selectNum),
        this.selectPct
      ]
      this.chartConfig.chartSettings.showLine = [this.selectPct]
      this.chartConfig.chartSettings.axisSite.right = [this.selectPct]
      this.$emit('googlereportsPct', val)
    },
    changeNum(val) {
      this.selectNum = val
      this.chartConfig.columns = [
        'name',
        this.switch(this.selectNum),
        this.selectPct
      ]
      this.chartConfig.chartSettings.showLine = [this.selectPct]
      this.chartConfig.chartSettings.axisSite.right = [this.selectPct]
      this.$emit('googlereports', val)
    },
    switch(val) {
      var name = ''
      let that = this
      switch (val) {
        case 'IMPRESSIONS':
          name = 'impressions'
          that.selectName = '展示次数'
          break
        case 'CLICKS':
          name = 'clicks'
          that.selectName = '点击次数'
          break
        case 'COST':
          name = 'exchangeRateCost'
          that.selectName = '消耗'
          break
      }
      return name
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #000;
  .el-select {
    width: 100px;
    margin: 0 10px;
  }
}
</style>
